import templates from './cameraMotionTemplates.json'

export const CAMERA_MOTION_TEMPLATES = templates as readonly unknown[]
